import { render, staticRenderFns } from "./AddEditPartner.vue?vue&type=template&id=1064acdc&scoped=true"
import script from "./AddEditPartner.vue?vue&type=script&lang=js"
export * from "./AddEditPartner.vue?vue&type=script&lang=js"
import style0 from "./AddEditPartner.vue?vue&type=style&index=0&id=1064acdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1064acdc",
  null
  
)

export default component.exports